// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery' //全局引入jquery
import Axios from './api/axios'; //
import ElementUI from 'element-ui'; //引入element-ui组件
import VueCookies from 'vue-cookies' // cookies
import echarts from 'echarts'; //绑定echarts
import 'babel-polyfill'; //兼容ie
Vue.prototype.$echarts = echarts
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
import promise from 'es6-promise';
promise.polyfill();
import 'element-ui/lib/theme-chalk/index.css';
import "./scss/login.css";
import "./scss/mystyle.css";
import "./scss/mystyleForCode.css";
import "./scss/css.css";
import "./scss/nav.css";
import "./scss/bookIndex.css"

import '../static/js/Scroll';

import eventBus from '@/Utils/eventBus'; //消息组件
Vue.prototype.$eventBus = eventBus;

// import htmlToPdf from '../static/js/htmlToPdf';
// Vue.use(htmlToPdf)
// import "./scss/bookIndex.css";
function GetQueryString(name) { //获取url字符串字段函数
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
};

// function transferText(value) {
//     value = value.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&nbsp;/g, '').replace(/&#183;/g, '.').replace(/\n/g, '<br/>').replace(/\r/g, '<br/>')
//     return value
// }
// function baseAddr() {
//     return 'http://testcase.drcnet.com.cn/front/'
// }
// import globalVue from '../static/js/golbalHttp';
// var globalVue = '/front/';
var globalVue = '/front/';
// var globalVue = 'http://10.0.0.211:2024/';

Vue.prototype.$global = globalVue

// 文章下载
var fullUrlDownload = 'http://caselib.drcnet.com.cn/front/'
Vue.prototype.$fullUrlDownload = fullUrlDownload
// window.globalHttp ='http://testcase.drcnet.com.cn/front/'
Vue.use(ElementUI); //挂载 element-ui
Vue.use(VueCookies); //挂载 cookie
import JsEncrypt from 'jsencrypt' //RSA加密


Vue.config.productionTip = false

//添加vue全局方法
Vue.prototype.$axios = Axios;
// Vue.prototype.$baseAddr = baseAddr;
Vue.prototype.$GetQueryString = GetQueryString;
// Vue.prototype.$transferText = transferText;
Vue.prototype.jsEncrypt = JsEncrypt



function IEVersion() {
    //取得浏览器的userAgent字符串
    var userAgent = navigator.userAgent;
    //判断是否IE浏览器
    var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
    var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    return isIE;
};


// import 'https://logcollection.drcnet.com.cn/collection/javascript/8'
router.afterEach((to, from) => {
    try {
        LogCollection.init();
    } catch (error) {
        // console.log(error);
    }
})

// function openDocPage(docid, leafid) {
//     if (IEVersion()) {
//         window.open("");
//     } else {
//         window.open("");
//     }
// }

router.beforeEach((to, from, next) => {
    // VueCookies.set("drcnet_token", '1f3ab8a1c92745bc80a8b4a2f96a06e8');
    // window.sessionStorage.setItem("Authorization", '1f3ab8a1c92745bc80a8b4a2f96a06e8');
    // next()
    // return

    var that = this;
    if (to.path != '/') {
        // console.log(VueCookies.get('drcnet_token'));
        // if (VueCookies.get('drcnet_token') == null) {
        $.ajax({
            url: "https://user.drcnet.com.cn/userapi/loginController/initLoginP?flag=initp", //initp 查询目前用户登录状态，logoutp 退出登录
            type: "post",
            dataType: "jsonp", //指定服务器返回的数据类型
            jsonpCallback: "showData", //指定回调函数名称
            xhrFields: { withCredentials: true },
            crossDomain: true,
            async: false,
            success: function (res) {
                VueCookies.set("drcnet_IsAdvIP", res.isAdv);
                console.log(res);
                if (res.UserToken != null && res.UserToken != '') {
                    Axios
                        .post("/autoLogin", { token: res.UserToken })
                        .then(res => {
                            if (res.data.code == 0 && res.data.data != null) {
                                let { token, userName } = res.data.data.data;
                                VueCookies.set("drcnet_userName", userName);
                                VueCookies.set("drcnet_token", token);
                                window.sessionStorage.setItem("Authorization", token);
                                VueCookies.set("drcnet_isInstitute", res.data.data.isInstitute);
                                // VueCookies.remove("drcnet_teacherId");
                                if (res.data.data.teacherId != null) {
                                    document.cookie = `drcnet_teacherId=${res.data.data.teacherId}`;
                                }
                                next();
                                try {
                                    LogCollection.send(6); //登录埋点
                                } catch (error) {
                                    // console.log(error);
                                }
                                // if (!that.backUrl) {
                                //     router.push('/home');
                                // } else {
                                //     // router.go(-1);
                                // }
                            }
                        });

                } else {
                    next();
                }
            }
        });

    } else if (to.path == '/article' && IEVersion()) {
        var path = to.fullPath.replace(/article/g, 'article1');
        next(path);
    } else {
        next()
    }

    try {
        LogCollection.end();
    } catch (error) {
        // console.log(error);
    }
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js